import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { entityName } from '@qtek/shared/models';

import { HttpEntityManager } from './../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class PersonService extends HttpEntityManager<any, any> {
  protected http = inject(HttpClient);

  entityName: entityName = 'Person';

  constructor() {
    super();
  }

  updatePerson(personId: string, payload: any = {}) {
    return this.put(payload, personId);
  }
}
